import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useDispatch, useSelector } from "react-redux";
import {
  eventStatusListPageResetState,
  getEventStatusListPageData,
  stopAction,
  stopAllAction,
} from "../../store/event-status-list-page.store";
import EventStatusListView from "../../views/mobile-frame/event-list/EventStatusListView";
import { Box, makeStyles } from "@material-ui/core";
import PullToRefresh from "react-simple-pull-to-refresh";

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
}));

const EventStatusListContainer = ({ eklok }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { token } = useContext(AuthContext);

  const { eventStatusList, error, loading } = useSelector((state) => {
    return state.eventStatusListPage;
  });

  console.log("eventStatusList", eventStatusList);

  const onStopAllActionPress = () => {
    dispatch(
      stopAllAction({
        token: token,
        eklok: eklok,
      }),
    );
  };

  const onStopOnItemClick = (event) => {
    dispatch(
      stopAction({
        token: token,
        eklok: eklok,
        actionId: event.ACTION_ID,
        actionType: event.ACTION_TYPE,
        cmd: "STOP",
      }),
    );
  };

  const onRefresh = () =>
    new Promise((resolve, reject) => {
      dispatch(getEventStatusListPageData({ token: token, eklok: eklok }));
      resolve();
    });

  useEffect(() => {
    dispatch(getEventStatusListPageData({ token: token, eklok: eklok }));
    return () => dispatch(eventStatusListPageResetState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PullToRefresh onRefresh={onRefresh} pullingContent={false}>
      {loading ? <Loading /> : null}
      <Box className={classes.container}>
        {error ? (
          <Error
            message={{ message: error.message }}
            onClose={() => {
              dispatch(
                getEventStatusListPageData({ token: token, eklok: eklok }),
              );
            }}
          />
        ) : null}
        {eventStatusList ? (
          <EventStatusListView
            eventStatusList={eventStatusList}
            eklok={eklok}
            onStopAllActionPress={onStopAllActionPress}
            onStopOnItemClick={onStopOnItemClick}
          />
        ) : null}
      </Box>
    </PullToRefresh>
  );
};

export default EventStatusListContainer;
